import s from './divider.module.css';

const Divider = () => {
    return <hr className={s.divider} />;
};

export default Divider;
